import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { ChemicalElement } from '@app/store/shared/models';
import { Elements, GetElementsValue } from '../models';

export const elementsActions = createActionGroup({
    source: 'Elements',
    events: {
        'Get Elements': props<{ value: GetElementsValue }>(),
        'Get Elements Success': props<{ payload: Elements }>(),
        'Get Elements Error': props<{ code: number }>(),

        'Get Elements Lookup': emptyProps(),
        'Get Elements Lookup Success': props<{ payload: ChemicalElement[] }>(),
        'Get Elements Lookup Error': props<{ code: number }>(),

        Clear: emptyProps(),
    },
});
